import React from "react";
import "./JyotirlingaPackage.css";

const itinerary = [
  { day: "Day 1", places: ["Pune", "Bhimashankar", "Trimbakeshwar", "Nashik", "Panchavati"], stay: "Night Stay – Nashik" },
  { day: "Day 2", places: ["Nashik", "Shirdi", "Shani Shingnapur"], stay: "Night Stay – Shirdi" },
  { day: "Day 3", places: ["Shirdi", "Grishneshwar", "Ellora", "Bhadra Maruti", "Pune"], stay: "Return to Pune" },
];

const vehicles = [
  { name: "Sedan Cab", price: "₹15,000", icon: "🚘" },
  { name: "Ertiga Cab", price: "₹18,000", icon: "🚙" },
  { name: "Kia Carens", price: "₹20,500", icon: "🚗" },
  { name: "Innova Crysta", price: "₹22,500", icon: "🚐", popular: true },
];

export default function JyotirlingaPackage() {
  return (
    <section className="jyotirlinga-package">
      <div className="package-container">

        {/* Header */}
        <div className="package-header">
          <img
            src="/images/logo.jpg"
            alt="Garud Cabs"
            className="garud-logo"
          />

          <div className="header-content">
            <span className="package-badge">2 Nights • 3 Days</span>
            <h1>Jyotirlinga Darshan Package</h1>
            <p>
              A complete spiritual journey from Pune with comfortable Commercial
              cab travel and an all-inclusive transportation package.
            </p>
          </div>
        </div>

        {/* Route */}
        <div className="route-banner">
          <span className="route-label">Complete Route</span>
          <div className="route-text">
            Pune <b>→</b> Bhimashankar <b>→</b> Trimbakeshwar <b>→</b> Nashik
            <b> → </b> Panchavati <b>→</b> Shirdi <b>→</b> Grishneshwar
            <b> → </b> Ellora <b>→</b> Bhadra Maruti
            <b> → </b> Shani Shingnapur <b>→</b> Pune
          </div>
        </div>

        <div className="main-grid">

          {/* Itinerary */}
          <div className="card itinerary-card">
            <div className="section-heading">
              <span>03</span>
              <div>
                <small>TRAVEL PLAN</small>
                <h2>3-Day Itinerary</h2>
              </div>
            </div>

            <div className="timeline">
              {itinerary.map((item, index) => (
                <div className="timeline-item" key={item.day}>
                  <div className="day-number">{index + 1}</div>

                  <div className="day-details">
                    <h3>{item.day}</h3>

                    <div className="places">
                      {item.places.map((place, i) => (
                        <React.Fragment key={place}>
                          <span>{place}</span>
                          {i !== item.places.length - 1 && (
                            <b className="arrow">→</b>
                          )}
                        </React.Fragment>
                      ))}
                    </div>

                    <div className="stay">
                      🏨 {item.stay}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Package Details */}
          <div className="side-column">

            <div className="card included-card">
              <span className="mini-label">ALL-INCLUSIVE TRAVEL</span>
              <h2>Everything Included</h2>

              <div className="included-grid">
                <div>✓ Fuel Charges</div>
                <div>✓ Toll Charges</div>
                <div>✓ Parking Charges</div>
                <div>✓ Driver Food</div>
                <div>✓ Entry Fees</div>
                <div>✓ Driver Allowance</div>
              </div>

              <div className="no-hidden">
                ✓ No Extra Transportation Charges
              </div>
            </div>

            <div className="card stay-card">
              <h3>🏨 Night Stay Plan</h3>

              <div className="stay-row">
                <span>Night 01</span>
                <strong>Nashik</strong>
              </div>

              <div className="stay-row">
                <span>Night 02</span>
                <strong>Shirdi / Grishneshwar Side</strong>
              </div>
            </div>

            <div className="not-included">
              <strong>Guest Expenses Not Included:</strong>
              Guest hotel accommodation, breakfast, lunch and dinner are not
              included in the package.
            </div>
          </div>
        </div>

        {/* Pricing */}
        <div className="pricing-section">
          <div className="pricing-heading">
            <div>
              <span className="mini-label">CHOOSE YOUR CAB</span>
              <h2>Package Price</h2>
            </div>

            <p>Complete 2 Nights / 3 Days Tour</p>
          </div>

          <div className="vehicle-grid">
            {vehicles.map((vehicle) => (
              <div
                className={`vehicle-card ${
                  vehicle.popular ? "popular" : ""
                }`}
                key={vehicle.name}
              >
                {vehicle.popular && (
                  <span className="popular-tag">POPULAR</span>
                )}

                <div className="vehicle-icon">{vehicle.icon}</div>
                <h3>{vehicle.name}</h3>
                <small>Package Starting At</small>
                <div className="price">{vehicle.price}</div>
                <span className="trip-text">2 Nights • 3 Days</span>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="booking-box">
          <div>
            <span>GARUD CABS • PUNE</span>
            <h2>Book Your Jyotirlinga Darshan</h2>
            <p>
              Comfortable Commercial Cab • Experienced driver • Complete tour
              package
            </p>
          </div>

          <a href="tel:+919970007784" className="book-btn">
            Book Your Cab →
          </a>
        </div>

      </div>
    </section>
  );
}